import dayjs from "dayjs";

export default (token: string): Date => {
  const tokenFormated = JSON.parse(window.atob(token.split(".")[1]));
  return dayjs.unix(tokenFormated.exp).toDate();
};
